const locationTypeValues = [
  { title: "Any", value: "" },
  { title: "Urban", value: "1" },
  { title: "Suburban", value: "2" },
  { title: "Rural", value: "3" },
];

export default locationTypeValues;
